module.exports = __webpack_public_path__ + "img/moonly-full-blanc.4f12297e.png";